<!--zx_frame_db.auth_zx_user（用户表）-table-->
<!--参数添加，1、config.js business中添加：zxUser: '后台地址'-->
<!--参数添加，2、global.js businessFlag中添加：zxUser: 'zxUser'-->
<template>
  <div class="main-area">
    <el-breadcrumb separator=":">
      <el-breadcrumb-item>当前位置</el-breadcrumb-item>
      <el-breadcrumb-item>在线反馈</el-breadcrumb-item>
    </el-breadcrumb>
    <!--查询区域-->
<!--    <el-row class="margin-top-10">-->
<!--      <el-col :span="1" class="margin-top-10">-->
<!--        <label class="search-label">-->
<!--          姓名:-->
<!--        </label>-->
<!--      </el-col>-->
<!--      <el-col :span="4" class="margin-top-10">-->
<!--        <el-input v-model="searchForm.xm"-->
<!--                  :size="GLOBAL.config.systemSize"-->
<!--                  placeholder="姓名"-->
<!--                  maxlength="32" clearable></el-input>-->
<!--      </el-col>-->
<!--      <el-col :span="2" class="margin-top-10">-->
<!--        <label class="search-label">-->
<!--          身份证号:-->
<!--        </label>-->
<!--      </el-col>-->
<!--      <el-col :span="4" class="margin-top-10">-->
<!--        <el-input v-model="searchForm.sfzh"-->
<!--                  :size="GLOBAL.config.systemSize"-->
<!--                  placeholder="身份证号"-->
<!--                  maxlength="32" clearable></el-input>-->
<!--      </el-col>-->
<!--      <el-col :span="2" class="margin-top-10">-->
<!--        <label class="search-label">-->
<!--          手机号:-->
<!--        </label>-->
<!--      </el-col>-->
<!--      <el-col :span="4" class="margin-top-10">-->
<!--        <el-input v-model="searchForm.sjh"-->
<!--                  :size="GLOBAL.config.systemSize"-->
<!--                  placeholder="手机号"-->
<!--                  maxlength="32" clearable></el-input>-->
<!--      </el-col>-->
<!--      <el-col :span="1" class="margin-top-10">-->
<!--        <label class="search-label">-->
<!--          角色:-->
<!--        </label>-->
<!--      </el-col>-->
<!--      <el-col :span="4" class="margin-top-10">-->
<!--        <el-select v-model="searchForm.yhlx"-->
<!--                   :size="GLOBAL.config.systemSize"-->
<!--                   placeholder="角色"-->
<!--                   style="width: 100%;" clearable-->
<!--        >-->
<!--          &lt;!&ndash; <el-option label="&#45;&#45;请选择&#45;&#45;" value=""></el-option> &ndash;&gt;-->
<!--          <el-option :label="item.text2" :value="item.uuid"-->
<!--                     v-for="item in rolesData"-->
<!--                     :key="item.uuid"></el-option>-->
<!--        </el-select>-->
<!--      </el-col>-->
<!--      <el-col :span="2" class="margin-top-10">-->
<!--        <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询-->
<!--        </el-button>-->
<!--      </el-col>-->
<!--    </el-row>-->
    <el-table style="width: 100%"
              :data="tableData"
              @selection-change="tableSelectionChange"
              element-loading-text="数据处理中...请稍等..."
              v-loading="loading">
      <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
      <!--姓名-->
      <el-table-column prop="cjr" label="反馈人" align="center"/>
      <el-table-column prop="fklx" label="反馈类型" width="100px" align="center">
        <template slot-scope="scope">
          {{scope.row.fklx === '1'?'建议':(scope.row.fklx==='2'?'投诉':'问题')}}
        </template>
      </el-table-column>
      <el-table-column prop="ssqhmc" label="所属区划" align="center"/>
<!--      <el-table-column prop="fknr" label="反馈内容" align="center"/>-->
      <el-table-column prop="fkzt" label="反馈状态" width="100px" align="center">
        <template slot-scope="scope">
          {{scope.row.fkzt === '1'?'未处理':'已处理'}}
        </template>
      </el-table-column>
      <el-table-column prop="cjsj" label="反馈时间" align="center" :formatter="formatterTime"></el-table-column>
      <el-table-column prop="scope" label="相关照片" align="center">
        <template slot-scope="scope">
          <el-dropdown v-if="scope.row.fjList.length != 0">
            <div style="color: #2b68e4; cursor:pointer;">查看图片</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in scope.row.fjList" :key="index" @click.native="previewImage(item.url)">图片{{index+1}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
	  <el-table-column prop="clr" label="处理人" align="center"/>
<!--	  <el-table-column prop="hfxx" label="回复信息" align="center"/>-->
      <el-table-column prop="scope" label="操作" align="center">
        <template slot-scope="scope">
          <el-dropdown>
                <span class="el-dropdown-link operator-text">
                  选择操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :icon="item.icon" v-for="item in getSource(scope.row)"
                                :key="item.method"
                                @click.native="handleCommon(item.method, scope.row)">
                {{item.title}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="margin-top-10 margin-bottom-20"
      @size-change="tableSizeChange"
      @current-change="currentChange"
      :current-page="pagination.currentPage"
      :page-sizes="pagination.pageSizeList"
      :page-size="pagination.pageSize"
      :layout="pagination.layout"
      :total="pagination.total">
    </el-pagination>
    <el-dialog
      title="反馈受理"
      :show-close="false"
      :visible.sync="viewVisibleFlag"
      :destroy-on-close="true"
    >
      <el-input type="textarea" v-model="slDic.hfxx" placeholder="请输入受理情况"></el-input>
      <el-row class="margin-top-10">
        <el-button @click="closeDialog" style="margin: 0 10px;" :size="GLOBAL.config.systemSize">关闭</el-button>
        <el-button type="primary" @click="saveData" style="margin: 0 20px;"
                   :size="GLOBAL.config.systemSize">受理
        </el-button>
      </el-row>
    </el-dialog>
    <ImagePreview ref="imagePreview"></ImagePreview>
    <fkInfo ref="fkInfo"></fkInfo>
  </div>
</template>
<script>
  import ImagePreview from "../../components/ImagePreview"
  import fkInfo from "../../components/fkInfo"
    export default {
        name: 'RelFlect',
        components: {
            ImagePreview,
            fkInfo
        },
        data () {
            return {
                slDic: {
                    hfxx: '',
                    uuid: ''
                },
                viewVisibleFlag: false,
                yhqx: JSON.parse(localStorage.getItem('gcUserInfo')).yhqx,
                // 查询表单
                searchForm: {
                    xm: '',
                    sjh: '',
                    sfzh: '',
                    ssqhdm: ''
                },
                tableData: [],
                // 字典数据
                dictionary: {
                    sex: JSON.parse(unescape(localStorage.getItem(this.GLOBAL.config.dictionaryPre + this.GLOBAL.config.dictionary.sex))),
                    userStatus: JSON.parse(unescape(localStorage.getItem(this.GLOBAL.config.dictionaryPre + this.GLOBAL.config.dictionary.userStatus))),
                    treeData: []
                },
                // 资源权限控制，有的系统不需这么细，则全部为true
                source: {
                    add: true,
                    deleteBatch: true,
                    infoEdit: true,
                    infoView: true,
                    infoDelete: true,
                    resetPwd: true,
                    weChat: true
                },
                // 分页参数
                pagination: {
                    pageSizeList: [10, 20, 30, 40, 50],
                    pageSize: 10,
                    layout: 'total, sizes, prev, pager, next, jumper',
                    total: 0,
                    currentPage: 1
                },
                operationVisibleFlag: false,
                deleteBatchList: {
                    ids: [],
                    deleteFlag: false
                },
                loading: false,
                defaultProps: {
                    checkStrictly: true,
                    label: 'shortName',
                    value: 'id',
                    children: 'children',
                    expandTrigger: 'hover'
                },
                rolesData: [],
                roleMap: new Map()
            }
        },
        mounted () {
            this.init()
        },
        methods: {
            init: function () {
                // TODO 加载列表数据
                this.getTableData('init')
            },
            doSearch: function () {
                this.getTableData('init')
            },
            operationMethod: function (operateType, info) {
                this.$refs.operationTemplate.init(operateType, info ? info : null)
            },
            deleteBatch: function () {
                let _this = this
                _this.$confirm('确认删除当前选择' +
                    '的' + _this.deleteBatchList.ids.length + '条数据？？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.loading = true
                    _this.FUNCTIONS.systemFunction.interactiveData(
                        _this,
                        _this.GLOBAL.config.businessFlag.zxUser,
                        _this.GLOBAL.config.handleType.deleteLogicalBatch,
                        _this.deleteBatchList.ids,
                        'list',
                        resultData => {
                            _this.loading = false
                            if (resultData) {
                                _this.$message.success('删除成功～')
                                _this.getTableData('init')
                            } else {
                                _this.$message.warning('删除失败～')
                            }
                        }
                    )
                })
            },
            getSource: function (rowData) {
                let tempList = []
                if (rowData.fkzt != '2') {
                    tempList.push({icon: 'el-icon-edit', title: '受理', method: 'handleEdit'})
                }
                tempList.push({icon: 'el-icon-view', title: '反馈信息', method: 'handleView'})
                return tempList
            },
            handleCommon: function (type, rowData) {
                switch (type) {
                    case 'handleEdit':
                        this.handleEdit(rowData)
                        break
                    case 'handleView':
                        this.handleView(rowData)
                        break
                }
            },
            updateForm: function (rowData) {
                let _this = this;
                let params =  {
                    Personnel: {
                        UUID: rowData.uuid
                    }
                }
                params.baseService = "TGcUserServiceImpl";
                this.FUNCTIONS.systemFunction.interactiveData(
                    _this,
                    _this.GLOBAL.config.businessFlag.zxUser,
                    'jbUser',
                    params,
                    null,
                    resultData => {
                        _this.loading = false
                        if (resultData) {
                            if (resultData.code == '200') {
                                _this.$message.success('解绑成功～')
                                _this.getTableData('init')
                            } else {
                                _this.$message.warning(resultData.errorMsg)
                            }
                        } else {
                            _this.$message.warning('解绑失败～')
                        }
                    },
                    () => {
                        _this.$message.warning('解绑失败～请联系管理员')
                    })
            },
            // 查看反馈信息
            handleView: function (rowData) {
                this.$refs.fkInfo.initInfo(rowData)
            },
            // 编辑
            handleEdit: function (rowData) {
                this.slDic.uuid = rowData.uuid
                this.viewVisibleFlag = true
            },
            // 关闭弹出框
            closeDialog: function () {
                this.slDic = {
                    uuid: '',
                    hfxx: ''
                }
                this.viewVisibleFlag = false
            },
            // 受理保存
            saveData: function () {
                let _this = this
                if (!this.slDic.hfxx) {
                    this.slDic.hfxx = '已受理'
                }
                let param = {
                    info: this.slDic,
                    baseService: 'TGcZxfkServiceImpl',
                    type: 'updateAll'
                }
                this.loading = true
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false
                        if (resultData) {
                            this.viewVisibleFlag = false
                            this.getTableData('init')
                            _this.$message.success('受理成功～')
                        } else {
                            _this.$message.warning('受理失败～')
                        }
                    }
                )
            },
            // 获取列表
            getTableData: function (initPageFlag) {
                this.loading = true
                let _this = this, searchParams = this.searchForm;
                _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
                let paginationData = _this.FUNCTIONS.systemFunction.paginationSet(
                    initPageFlag ? 1 : _this.pagination.currentPage,
                    initPageFlag ? 10 : _this.pagination.pageSize,
                    searchParams)
                // 3、 调接口获取数据
                paginationData.baseService = 'TGcZxfkServiceImpl'
                _this.FUNCTIONS.systemFunction.interactiveData(
                    _this,
                    _this.GLOBAL.config.businessFlag.zxUser,
                    _this.GLOBAL.config.handleType.getPage,
                    paginationData,
                    null,
                    resultData => {
                        _this.loading = false
                        if (resultData) {
                            // 结果参数赋值
                            _this.pagination.pageSize = resultData.obj.size
                            _this.pagination.total = resultData.obj.total
                            _this.pagination.currentPage = resultData.obj.current
                            _this.tableData = resultData.obj.records
                        } else {
                            _this.$message.warning('获取列表数据失败～')
                        }
                    },
                    () => {
                        _this.loading = false
                    }
                )
            },
            // 分页方法
            tableSizeChange: function (pageSize) {
                this.pagination.pageSize = pageSize
                this.getTableData()
            },
            currentChange: function (current) {
                this.pagination.currentPage = current
                this.getTableData()
            },
            // 复选框选择事件
            tableSelectionChange: function (targetList) {
                let ids = []
                targetList.forEach(item => {
                    ids.push(item.id)
                })
                this.deleteBatchList.ids = ids
                if (this.deleteBatchList.ids &&
                    this.deleteBatchList.ids.length > 0) {
                    this.deleteBatchList.deleteFlag = true
                } else {
                    this.deleteBatchList.deleteFlag = false
                }
            },
            // 查看图片
            previewImage: function (url) {
                this.$refs.imagePreview.handlePictureCardPreview(url)
            },
            formatterTime(row, column, data) {
                if (!data) {
                    return "";
                }
                var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
                return data.replace(reg, "$1-$2-$3 $4:$5:$6");
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/setFunction/RelFlect.vue